import { render, staticRenderFns } from "./AboutBanner.vue?vue&type=template&id=002541f4&scoped=true&"
import script from "./AboutBanner.vue?vue&type=script&lang=js&"
export * from "./AboutBanner.vue?vue&type=script&lang=js&"
import style0 from "./AboutBanner.vue?vue&type=style&index=0&id=002541f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002541f4",
  null
  
)

export default component.exports